import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BlockModel } from 'src/app/core/models/BlockModel';
import { PartnerQueryStatus } from 'src/app/core/models/PartnerQueryStatus';
import { QueryCategoryModel } from 'src/app/core/models/QueryCategoryModel';
import { QueryDetailModel } from 'src/app/core/models/QueryDetailModel';
import { QueryModel } from 'src/app/core/models/QueryModel';
import { QueryStatus } from 'src/app/core/models/QueryStatus';
import { QuerySubCategoryModel } from 'src/app/core/models/QuerySubCategoryModel';
import { RegisteredUserModel } from 'src/app/core/models/RegisteredUserModel';
import { SubDepartmentModel } from 'src/app/core/models/SubDepartmentModel';
import { User } from 'src/app/core/models/user';
import { DbMasterService } from 'src/app/core/services/db-master.service';
import { UserService } from 'src/app/core/services/user.service';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { PriorityLevelEnum, PriorityLevelMapping } from 'src/app/core/models/PriorityLevelEnum';
import { formatDate } from '@angular/common';
import { NzUploadChangeParam } from 'ng-zorro-antd/upload';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ClarificationQueryListService } from '../clarification-query-list.service';
import { Constants } from 'src/app/constants/constants';
import { openViewAttachmentsModal, openViewCommentsModal } from '../Shared/CommonHelper';
import { QueryCommentModel } from 'src/app/core/models/QueryCommentModel';
import { NzStatus } from 'ng-zorro-antd/core/types';
import { AddAttachmentsComponent } from '../add-attachments/add-attachments.component';

@Component({
  selector: 'app-update-query',
  standalone: false,
  templateUrl: './update-query.component.html',
  styleUrl: './update-query.component.less'
})
export class UpdateQueryComponent {
  @Input() queryModel!: QueryModel;
  @Input() queryPermission: any;
  currentUser: User = new User();

  queryCode: number = 0;
  partnerQueryStatus: PartnerQueryStatus = PartnerQueryStatus.New;
  priorityLevelMapping = PriorityLevelMapping;
  priorityLevels = Object.values(PriorityLevelEnum);
  queryDetail: QueryDetailModel = new QueryDetailModel();
  queryComment: QueryCommentModel = new QueryCommentModel();

  blockMaster: BlockModel[] = [];
  departmentMaster: SubDepartmentModel[] = [];
  subDeptMaster: SubDepartmentModel[] = [];
  deptSubDeptMaster: SubDepartmentModel[] = [];
  categoryMaster: QueryCategoryModel[] = [];
  subCatMaster: QuerySubCategoryModel[] = [];
  partnerUserMaster: RegisteredUserModel[] = [];
  catSubCatMaster: QuerySubCategoryModel[] = [];
  selectedCCPartnerUsers = [];
  selectedCCUsers: RegisteredUserModel[] = [];
  selectedCCSubDepts: { Id: string; Value: string }[] = [];
  query: QueryModel = new QueryModel();
  output: any;
  queryStatus: string = "New";
  requestedDate: Date = new Date();


  CCSubDepartmentsMaster: { Id: string; Value: string }[] = [];

  requestorDetail: User = new User();
  subjectMaxLength: number = 80;
  dropdownSettings = {};
  dropdownSettingsDept = {};
  updateQueryForm!: FormGroup;
  files: File[] = [];
  partnerUploadedAttachmtCnt = 0;
  internalUserUploadedAttachmtCnt = 0;

  queryNewEnum = QueryStatus.New;
  queryAssignedToDeptEnum = QueryStatus.AssignedToDeptRep;
  queryAnsweredByDeptEnum = QueryStatus.QueryAnsweredByDeptRep;
  queryAnsweredBySponsorEnum = QueryStatus.QueryAnsweredBySponsor;
  queryRecycledEnum = QueryStatus.Recycled;
  queryReOpenedEnum = QueryStatus.ReOpened;

  isCategoryCommentVisible = false;
  isContractNumberVisible = false;
  isAFEVisible = false;
  isWOVisible = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    private dbMasterService: DbMasterService,
    private modalService: NzModalService,
    private messageService: NzMessageService,
    private queryService: ClarificationQueryListService,
    private fb: FormBuilder) {
    const queryCodeParam = this.route.snapshot.paramMap.get('queryCode');
    this.queryCode = queryCodeParam ? +queryCodeParam : 0;

  }

  ngOnInit() {
    this.currentUser = this.userService.getCurrentUser();    
    this.initialiseData();
    this.initializeForm();
    this.initialiseMasterData();

    if (this.queryCode === 0) {
      this.router.navigate(['/home']);
    }
  }
  public getNzStatusColor(control: string): NzStatus {
    const formControl = this.updateQueryForm.get(control);
    if (formControl?.touched && formControl.invalid) {
      return 'error';
    }
    return '';
  }
  initializeForm() {
    
    var isDisabled = !this.queryPermission.canUpdateRequestdetails;
    this.updateQueryForm = this.fb.group({
      // Query Details
      ccEmails: [this.queryModel.QueryDetail.CCEmails, this.semiColonSeparatedEmailsValidator],
      confidential: [this.queryModel.QueryDetail.Is_Confidential],

      //Requestor Details
      requestorName: [{value: this.currentUser.IsRFCAdmin ? this.currentUser : this.currentUser.User_Name,disabled: !this.currentUser.IsRFCAdmin}],
      requestorEmail: [{ value: this.currentUser.Email, disabled: true }],
      company: [{ value: this.currentUser.Company?.Company_Name, disabled: true }],
      
      //Clarification Request Details
      department: [{ value: '', disabled: isDisabled }, Validators.required],
      subDepartment: [{ value: '', disabled: isDisabled }, Validators.required],
      ccSubDepartment: [{ value: [], disabled: !this.queryPermission.CanUpdateCCDepartments }], // CC Sub Departments
      cc: [{ value: [], disabled: !this.queryPermission.canUpdateCCUser }], // Multi-select dropdown
      partnerComments: [this.queryModel.QueryDetail.Partner_Comment, Validators.required], // Mandatory field
      Company_Restricted: [{value: this.queryModel.QueryDetail.Company_Restricted || false,disabled: isDisabled}],
      Clarification_Cat_Code: [{ value: '', disabled: isDisabled }, Validators.required],
      Clarification_SubCat_Code: [{ value: '', disabled: isDisabled }, Validators.required],
      letterReferenceNumber: [{value: this.queryModel.QueryDetail.LetterReference_Number,disabled: isDisabled}],
      afeNumber: [{value: this.queryModel.QueryDetail.AFE_Number,disabled: isDisabled}],
      workOrderNumber: [{value: this.queryModel.QueryDetail.Work_Order_Number,disabled: isDisabled}],
      contractNumber: [{value: this.queryModel.QueryDetail.Contract_Number,disabled: isDisabled}],
      categoryComment: [{value: this.queryModel.QueryDetail.Category_Comments,disabled: isDisabled}, Validators.required],
      additionalComments: [this.queryModel.QueryDetail.Comment, Validators.required],
    });

  }

  onSubmit() {
    if (this.updateQueryForm.valid) {
      
      // Call the service to update the query
    } else {
      
      this.updateQueryForm.markAllAsTouched();
    }
  }
  // Custom validator for semicolon-separated email addresses
  semiColonSeparatedEmailsValidator(control: AbstractControl): ValidationErrors | null {
    const emailList = control.value?.split(';').map((email: string) => email.trim());
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email regex

    if (!control.value) {
      return null; // No value, no validation error
    }

    for (const email of emailList) {
      if (email && !emailRegex.test(email)) {
        return { invalidEmail: true }; // Return error if any email is invalid
      }
    }

    return null; // All emails are valid
  }

  initialiseData() {
    this.partnerUserMaster = [];
    this.departmentMaster = [];
    this.queryDetail = this.queryModel.QueryDetail;
    if (this.queryDetail.Clarification_Cat_Code == undefined || this.queryDetail.Clarification_Cat_Code == '0')
      this.queryDetail.Clarification_Cat_Code = '';
    this.partnerUploadedAttachmtCnt = this.queryDetail.FileAttachments.filter(s => s.Partner_UploadedFile).length;
    this.internalUserUploadedAttachmtCnt = this.queryDetail.FileAttachments.filter(s => !s.Partner_UploadedFile).length;
  }

  initialiseMasterData() {
    this.dbMasterService.getMasterDetails().subscribe({
      next: (response) => {

        this.output = response.output;
        this.blockMaster = this.output.Block as [];

        this.categoryMaster = this.output.Category as [];
        this.subCatMaster = this.output.SubCategory as [];

        this.departmentMaster = this.output.Department.filter((dept: { Active: any; }) => dept.Active) as [];
        this.subDeptMaster = this.output.SubDepartment.filter((subDept: { Active: any; }) => subDept.Active) as [];
        this.partnerUserMaster = this.output.PartnerUsers.filter((user: { Active: any; }) => user.Active) as [];
        this.deptSubDeptMaster = [];
        this.departmentMaster.forEach(element => {
          var subDepts = this.subDeptMaster.filter(a => a.Department_Code == element.Department_Code);
          subDepts.forEach(item => {
            this.CCSubDepartmentsMaster.push({ 'Id': item.Sub_Dept_Code, 'Value': element.Department_Name + ' - ' + item.Sub_Dept_Name });
          });
        });
        this.categoryMaster = this.output.Category as [];
        this.subCatMaster = this.output.SubCategory as [];
        this.partnerUserMaster = this.output.PartnerUsers.filter((s: any) => s.Active) as [];
        this.deptSubDeptMaster = this.catSubCatMaster = [];
        if (this.queryDetail.Department_Code != "0" && this.queryDetail.Department_Code != "") {
          this.deptSubDeptMaster = this.subDeptMaster.filter(item => item.Department_Code == this.queryDetail.Department_Code);
          var subDepts = this.deptSubDeptMaster.filter(a => a.Sub_Dept_Code == this.queryDetail.Sub_Dept_Code)
          if (subDepts.length == 0) {
            this.queryDetail.Sub_Dept_Code = "";
          }
        }
        if (this.queryDetail.Clarification_Cat_Code != "0" && this.queryDetail.Clarification_Cat_Code != "") {
          this.catSubCatMaster = this.subCatMaster.filter(item => item.Clarification_Cat_Code == this.queryDetail.Clarification_Cat_Code);
          this.setSubCategoryVisibility(this.queryModel.QueryDetail.Clarification_SubCat_Code);
        }
        if (this.queryDetail.CCUsers) {
          for (var i = 0; i < this.queryDetail.CCUsers.length; i++) {
            let user = this.partnerUserMaster.filter(s => s.User_Code == this.queryDetail.CCUsers[i]);
            if (user.length > 0) {
              this.selectedCCUsers.push(user[0]);
            }
          }
        }

        if (this.queryDetail.CCSubDepartments) {
          for (var i = 0; i < this.queryDetail.CCSubDepartments.length; i++) {
            let subDepts = this.CCSubDepartmentsMaster.filter(s => s.Id == this.queryDetail.CCSubDepartments[i]);
            if (subDepts.length > 0) {
              this.selectedCCSubDepts.push(subDepts[0]);
            }
          }
        }


        // Set the form values based on the query detail
        this.updateQueryForm.patchValue({
          department: this.queryDetail.Department_Code || '',
          subDepartment: this.queryDetail.Sub_Dept_Code || '',
          ccSubDepartment: this.queryDetail.CCSubDepartments || [],
          cc: this.queryDetail.CCUsers || [],
          Clarification_Cat_Code: this.queryDetail.Clarification_Cat_Code || '',
          Clarification_SubCat_Code: this.queryDetail.Clarification_SubCat_Code || ''          
        });
        this.updateQueryForm.markAllAsTouched();
      },
      error: (err) => {
        console.error('Error fetching master details:', err);
      }
    });
  }

  //#region Dropdown Change Events

  onDepartmentChange(department_Code: string) {
    this.deptSubDeptMaster = [];
    this.queryDetail.Sub_Dept_Code = "";

    // Clear the subDepartment field in the form
    this.updateQueryForm.patchValue({
      subDepartment: ''
    });

    this.deptSubDeptMaster = this.subDeptMaster.filter(item => item.Department_Code == department_Code);
  }
  onCategorySelect(category_Code: string) {
    this.catSubCatMaster = [];
    this.queryDetail.Clarification_Cat_Code = category_Code;
    this.queryDetail.Clarification_SubCat_Code = "";
    this.catSubCatMaster = this.subCatMaster.filter(item => item.Clarification_Cat_Code == category_Code);
    this.updateQueryForm.patchValue({
      Clarification_SubCat_Code: ''
    });
    
    if (category_Code == "1" || category_Code == "2") {
      this.updateQueryForm.get('Clarification_SubCat_Code')?.setValidators(Validators.required);
      
    } else {
      this.updateQueryForm.get('Clarification_SubCat_Code')?.clearValidators();
      
    }
    this.updateQueryForm.get('Clarification_SubCat_Code')?.updateValueAndValidity();
    
    this.resetToDefault();
  }
  onSubCategorySelect(SubCategory_Code : string) {
    this.resetToDefault();
    this.queryDetail.Clarification_SubCat_Code = SubCategory_Code??'';
    this.setSubCategoryVisibility(SubCategory_Code);
  }
  // Handle requestor change
  onRequestorChange(selectedUser: RegisteredUserModel): void {
    if (selectedUser) {
      this.updateQueryForm.patchValue({
        requestorEmail: selectedUser.Email,
        company: selectedUser.Company?.Company_Name,
        block: selectedUser.Block?.Block_Name
      });
    }
  }
  //#endregion


  handleChange({ file, fileList }: NzUploadChangeParam): void {
    const status = file.status;
    if (status !== 'uploading') {
      
    }
    if (status === 'done') {
      
    } else if (status === 'error') {
      
    }
  }

  //#region NotifyToPartner  

  openNotifyToPartnerModal() {
    if (!this.ifFormIsValid())
      return;
    this.modalService.confirm({
      nzTitle: 'Confirm!',
      nzContent: `Are you sure, you want to <b>Notify Partners?</b>`,
      nzOkText: 'Yes',
      nzOkType: 'primary',
      nzClosable: false,
      nzOkDanger: true,
      nzOnOk: () => this.notifyToPartner(),
      nzCancelText: 'No'
    });
  }
  notifyToPartner() {
    this.assignFormValuesToQueryModel();
    

    this.queryService.notifyToPartner(this.queryDetail, this.files).subscribe({
      next: (response: any) => {
        this.messageService.success("Partner has been notified successfully!", {
          nzDuration: Constants.SHOW_MESSAGE_DURATION,
        });
        this.redirectToQueryRequest();
      },
      error: (err: any) => {
        this.messageService.error(err.error || "An error occurred while notifying the partner.");
        console.error("Error notifying partner:", err);
      },
    });
  }
  //#endregion

  //#region NotifyToDepartment
  openNotifyToDepartmentModal() {
    if (!this.ifFormIsValid())
      return;
    this.modalService.confirm({
      nzTitle: 'Confirm!',
      nzContent: `Are you sure, you want to <b>Notify Department?</b>`,
      nzOkText: 'Yes',
      nzOkType: 'primary',
      nzClosable: false,
      nzOkDanger: true,
      nzOnOk: () => this.notifyToDepartment(),
      nzCancelText: 'No'
    });
  }

  notifyToDepartment() {
    this.assignFormValuesToQueryModel();
    this.queryService.sendRequestToDept(this.queryDetail, this.files).subscribe({
      next: (response: any) => {
        this.messageService.success("Department Representative has been notified successfully!", {
          nzDuration: Constants.SHOW_MESSAGE_DURATION,
        });
        this.redirectToQueryRequest();
      },
      error: (err: any) => {
        console.error("Error notifying department representative:", err);
        this.messageService.error(err.error || "An error occurred while notifying the department representative.");
      }
    });
  }

  //#endregion

  //#region AdditionalComment
  addAdditionalCommentModal() {
    if (!this.ifFormIsValid())
      return;
    this.modalService.confirm({
      nzTitle: 'Confirm!',
      nzContent: `Are you sure, you want to add <b>Additional Comment</b>?`,
      nzOkText: 'Yes',
      nzOkType: 'primary',
      nzClosable: false,
      nzOkDanger: true,
      nzOnOk: () => this.addAdditionalComment(),
      nzCancelText: 'No'
    });
  }
  addAdditionalComment() {

    this.queryComment = this.createQueryCommentModel();

    this.queryService.addAdditionalComment(this.queryComment, this.files).subscribe((response: any) => {
      this.messageService.success("An additional comment is added successfully!");
      this.reloadCurrentComponent();
    });
  }
  //#endregion
  
  //#region NotifyToRFCAdmin
  notifyToRFCAdminModal() {
    if (!this.ifFormIsValid())
      return;
    this.modalService.confirm({
      nzTitle: 'Confirm!',
      nzContent: `<input type="checkbox"></input> I <b>acknowledge</b> that the information provided has been approved by my supervisor and department managers and will be shared with external parties.?`,
      nzOkText: 'Notify RFC Admin',
      nzOkType: 'primary',
      nzClosable: false,
      nzOkDanger: true,
      nzOnOk: () => this.notifyToRFCAdmin(),
      nzCancelText: 'No'
    });
  }

  notifyToRFCAdmin() {
    this.queryComment = this.createQueryCommentModel();
    this.queryService.sendResponseToRFCAdmin(this.queryComment, this.files).subscribe({
      next: () => {
        this.messageService.success("RFC Admin has been Notified successfully!");
        this.redirectToQueryRequest();
      },
      error: (err) => {
        this.messageService.error(err.error);
      }
    });
  }
  //#endregion
  createQueryCommentModel(): QueryCommentModel {
    this.queryComment = new QueryCommentModel();
    this.queryComment.QueryCode = this.queryDetail.Clarification_Query_Code;
    this.queryComment.QueryDetailCode = this.queryDetail.Clarification_Query_Detail_Code;
    this.queryComment.Comment = this.updateQueryForm.value.additionalComments;
    this.queryComment.CommentAddedBy = this.currentUser.User_Code ?? 0;
    return this.queryComment;
  }
  assignFormValuesToQueryModel() {
    this.queryDetail.Department_Code = this.updateQueryForm.value.department;
    this.queryDetail.Sub_Dept_Code = this.updateQueryForm.value.subDepartment;
    this.queryDetail.CCSubDepartments = this.updateQueryForm.value.ccSubDepartment || [];
    this.queryDetail.CCUsers = this.updateQueryForm.value.cc || [];
    this.queryDetail.Partner_Comment = this.updateQueryForm.value.partnerComments;
    this.queryDetail.Company_Restricted = this.updateQueryForm.value.Company_Restricted;
    this.queryDetail.Clarification_Cat_Code = this.updateQueryForm.value.Clarification_Cat_Code;
    this.queryDetail.Clarification_SubCat_Code = this.updateQueryForm.value.Clarification_SubCat_Code;

    this.queryDetail.LetterReference_Number = this.updateQueryForm.value.letterReferenceNumber;
    this.queryDetail.Contract_Number = this.updateQueryForm.value.contractNumber;
    this.queryDetail.AFE_Number = this.updateQueryForm.value.afeNumber;
    this.queryDetail.Work_Order_Number = this.updateQueryForm.value.workOrderNumber;
    this.queryDetail.Category_Comments = this.updateQueryForm.value.categoryComment;
    this.queryDetail.Comment = this.updateQueryForm.value.additionalComments;
    this.queryDetail.Modified_By = (this.currentUser.User_Code ?? 0).toString();
  }
  notifyResponseToPartnerModal() {
    if (!this.ifFormIsValid())
      return;
    this.modalService.confirm({
      nzTitle: 'Confirm!',
      nzContent: `Are you sure, you want to <b>Notify Partner</b>?`,
      nzOkText: 'Yes',
      nzOkType: 'primary',
      nzClosable: false,
      nzOkDanger: true,
      nzOnOk: () => this.notifyResponseToPartner(),
      nzCancelText: 'No'
    });
  }
  notifyResponseToPartner() {
    this.queryComment = this.createQueryCommentModel();

    let CCUsers = this.updateQueryForm.value.cc || [];
    let CCSubDepts = this.updateQueryForm.value.ccSubDepartment || [];

    this.queryService.sendResponseToPartner(this.queryComment, CCUsers, CCSubDepts, this.files).subscribe((response: any) => {
      this.messageService.success("Partner has been notified successfully!");
      this.redirectToQueryRequest();
    }, (err) => {
      this.messageService.error(err.error);
    });
  }

  redirectToQueryRequest() {
    if (this.currentUser.IsRFCAdmin) {
      this.router.navigate(['/clarification-query/all_query_request']);
    }
    else {
      this.router.navigate(['/clarification-query/my-query']);
    }
  }
  viewAttachments(viewPartnerUploadedFiles: boolean) {
    this.queryModel.QueryDetail.Query_Reference_Number = this.queryModel.Query_Reference_Number;
    openViewAttachmentsModal(this.modalService, this.queryModel.QueryDetail, viewPartnerUploadedFiles);
  }
  viewComments() {
    openViewCommentsModal(this.modalService, this.queryModel.Query_Reference_Number, this.queryModel.QueryDetail.ConsolidatedComment);
  } 
  setSubCategoryVisibility(SubCategory_Code: string) {
    
    switch (SubCategory_Code?.toString()) {
      case "1":
      case "5":
        this.isContractNumberVisible = true;
        break;
      case "2":
      case "6":
        this.isAFEVisible = true;
        break;
      case "3":
      case "7":
        this.isWOVisible = true;
        break;
      case "4":
      case "8":
        this.isCategoryCommentVisible = true;
        break;
    } 
  this.enforcedCategoryCommentAsRequired();
  }
  enforcedCategoryCommentAsRequired() {
    if (this.isCategoryCommentVisible) {
      this.updateQueryForm.get('categoryComment')?.setValidators(Validators.required);      
    } else {
      this.updateQueryForm.get('categoryComment')?.clearValidators();      
    }
    this.updateQueryForm.get('categoryComment')?.updateValueAndValidity();
  }
  resetToDefault() {
    this.isCategoryCommentVisible = this.isContractNumberVisible = this.isAFEVisible = this.isWOVisible = false;
    this.queryDetail.LetterReference_Number = '';
    this.queryDetail.Contract_Number = '';
    this.queryDetail.AFE_Number = '';
    this.queryDetail.Work_Order_Number = '';
    this.queryDetail.Category_Comments = '';
    if(this.queryPermission.canUpdateRequestdetails) {
      this.updateQueryForm.patchValue({
        letterReferenceNumber: this.queryDetail.LetterReference_Number,
        contractNumber: this.queryDetail.Contract_Number,
        afeNumber: this.queryDetail.AFE_Number,
        workOrderNumber: this.queryDetail.Work_Order_Number,
        categoryComment: this.queryDetail.Category_Comments
      });
    }
  }

  
  ifFormIsValid(): boolean {
    if (this.updateQueryForm.valid) {
      return true;
    } else {
      this.updateQueryForm.markAllAsTouched();
      this.logReasonForInvalidForm();
      return false;
    }
  }
  logReasonForInvalidForm() {    
    Object.keys(this.updateQueryForm.controls).forEach(key => {
      const controlErrors = this.updateQueryForm.get(key)?.errors;
      if (controlErrors) {
        console.log(`Field: ${key}, Errors:`, controlErrors);
      }
    });
  }
  openFileUploadModal(): void {
      // Implement your logic to open the file upload modal here
       
      const modalRef = this.modalService.create({
        nzTitle: 'Add Attachments',
        nzClosable: true,
        nzWidth: '60%',
        nzFooter: null,
        nzAutofocus: null,
        nzContent: AddAttachmentsComponent,
        nzData: {
          uploadedFiles: this.files,
          alreadyUploadFileCount: this.files.length,
        },
      });
    
      // Listen to the onFilesUploadClicked event from the add-attachments component
      // and update the files array in the current component
      const instance = modalRef.getContentComponent();
      if (instance) {
        instance.onFilesUploadClicked.subscribe((uploadedFiles: File[]) => {
          
          this.files = []; // Clear the existing files array before adding new files
          this.files = [... uploadedFiles] ; // Update the files array with the uploaded files 
          
        });
      }   
    }

    reloadCurrentComponent() {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate([this.route.snapshot.url.join('/')]);
      });
    }
  
}
